import { KeyboardEvent, useState, useRef } from 'react';

interface UseChatInputBehaviorOptions {
  onSend: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  canSend?: boolean; // 送信可能かどうかの判定（メッセージがあるか等）
}

interface UseChatInputBehaviorReturn {
  handleKeyDown: (e: KeyboardEvent<HTMLTextAreaElement>) => void;
  isComposing: boolean;
  setIsComposing: (composing: boolean) => void;
}

/**
 * チャット入力の統一された送信挙動を提供するカスタムフック
 * 
 * 動作仕様:
 * - 変換中（IME入力中）のEnterでは送信しない
 * - Shift + Enter: 改行
 * - Enter のみ: 送信
 */
export const useChatInputBehavior = ({
  onSend,
  isLoading = false,
  disabled = false,
  canSend = true
}: UseChatInputBehaviorOptions): UseChatInputBehaviorReturn => {
  const [isComposing, setIsComposing] = useState(false);

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        // Shift + Enter: 改行（デフォルトの動作を許可）
        return;
      } else {
        // Enter のみ: 送信判定
        if (
          !isComposing &&    // 変換中でない
          !isLoading &&      // 読み込み中でない
          !disabled &&       // 無効化されていない
          canSend            // 送信可能（メッセージがある等）
        ) {
          e.preventDefault();
          onSend();
        } else {
          // 送信条件を満たさない場合は改行
          // （ただし変換中の場合はイベントを止めない）
          if (!isComposing) {
            // 送信できない状態でのEnterは何もしない
            e.preventDefault();
          }
        }
      }
    }
  };

  return {
    handleKeyDown,
    isComposing,
    setIsComposing
  };
};
